import React, { Component } from "react";
import CheckboxTree from "react-checkbox-tree";
import "react-checkbox-tree/lib/react-checkbox-tree.css";
import {
  Nav,
  NavItem,
  NavLink,
  FormGroup,
  Label,
  Input,
  Button,
  Modal,
  Form,
  Alert
} from "reactstrap";
import { CreateItem, UpdateItem, DeleteItem } from "../../helpers/crud";
import classnames from "classnames";
// import { AppSwitch } from '@coreui/react';
import { connect } from "react-redux";
import {
  applyMedia,
  applyNotMedia,
  applyType,
  filterAction,
  errorActions,
  fetchMyMediaList,
  selecteMyMediaList,
  applyChKey
} from "../../actions";
import myFetchWithId from "../../helpers/myFetch";
import Loader from 'react-loader-advanced';
import SelectedMedias from "./selectedMedias";
import { SearchChannel } from './mediasComponents/myMediaList';
import SaveItem from './saveItem';

const mapStateToProps = state => {
  return {
    typeTag:state.search.type,
    typeNotTag:state.search.typeNot,
    //media 
    source: state.search.source,
    sourceNot: state.search.sourceNot,
    channel: state.search.ch,
    channelNot: state.search.chNot,
    channelKey: state.search.chKeys,
    channelNotKey: state.search.chNotKeys,
    newsList: state.mediaLists.newsList,
    bbsList: state.mediaLists.bbsList,
    blogList: state.mediaLists.blogList,
    smList: state.mediaLists.smList,
    //
    filterTypeFromRedux: state.search.filterTypeFromRedux,
    checkedList: state.search.checkedList,
    savedMediaList: state.search.savedMediaList,
    selectedMediaId: state.search.selectedMediaId
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchMyMediaList: keepId => dispatch(fetchMyMediaList(keepId)),
    selecteMyMediaList: (id, array) => dispatch(selecteMyMediaList(id, array)),
    applyMedia: mediaList => dispatch(applyMedia(mediaList)),
    applyNotMedia: mediaList => dispatch(applyNotMedia(mediaList)),
    applyType: (filltertype,typeTag,typeList, checkedList, selecttype) =>
    dispatch(applyType(filltertype,typeTag,typeList, checkedList, selecttype)),
    filterAction: type => dispatch(filterAction(type)),
    updateError: (open, code, message) =>
    dispatch(errorActions.update(open, code, message)),
    applyChKey: (type,ch,keys) => dispatch(applyChKey(type,ch,keys))
  };
};

const mediaApi = "/v5/lowi/profile/sc";
const spinner = (
  <div className="lds-ripple">
    <div></div>
    <div></div>
  </div>
);

class MediaFilterComponent extends Component {
  constructor(props) {
    super(props);

    // this.cleanChecked = this.cleanChecked.bind(this);
    // this.selectAll = this.selectAll.bind(this);
    this.filter = this.filter.bind(this);
    this.apply = this.apply.bind(this);
    this.setType = this.setType.bind(this);
    this.checkMediaType = this.checkMediaType.bind(this);
    this.checkCh = this.checkCh.bind(this);
    this.handleListSelect = this.handleListSelect.bind(this);
    this.medialistTitle = this.medialistTitle.bind(this);
    this._removeChtoList = this._removeChtoList.bind(this);
    this.cleanChecked = this.cleanChecked.bind(this);

    this.state = {
      temp:[],
      tempList:[
        {type:"NEWS",checked:[]},
        {type:"BBS",checked:[]},
        {type:"SM",checked:[]},
        {type:"BLOG",checked:[]},
      ],
      typeTag:this.props.typeTag,
      typeTagNoT:this.props.typeNotTag,

      loading :false,
      displayMedia: this.props.newsList,

      checked: [],
      selectCh: [],
      checkedList: [
        {type:"NEWS",checked:[]},
        {type:"BBS",checked:[]},
        {type:"SM",checked:[]},
        {type:"BLOG",checked:[]},
      ],
      selectedMediaType: [false,false,false,false],
      filterType: this.props.filterTypeFromRedux,
      expanded: [],
      filterKeyword: "",
      activeTab: 0,
      allSelected: false,
      news: this.props.newsList,
      bbs: this.props.bbsList,
      blog: this.props.blogList,
      sm: this.props.smList,
      mediaType: [
        {
          title: "新聞",
          num: this.props.newsList ? this.props.newsList.length : 0
        },
        {
          title: "論壇",
          num: this.props.bbsList ? this.props.bbsList.length : 0
        },
        {
          title: "社群",
          num: this.props.smList ? this.props.smList.length : 0
        },
        {
          title: "部落格",
          num: this.props.blogList ? this.props.blogList.length : 0
        }
      ],
      myMediaName: "",
      nameMediaOpen: false,
      mediaNameAlert: false,
      mediaSelectAlert: false,
      myMediaOpen: false,
      disabledchecked: false,
      nameOpen: false,
      emptyAlert: false,
      groupName: "",
      saveMediaOpen: false,
      storeObj: [],
    };
  }

  processStoreObj = () =>{
    const personalList = []

    this.state.checkedList.forEach(media=>{
       media.checked.forEach(source=>{
        personalList.push({
          type : media.type,
          source : source,
          ch : '',
          chKey : '',
        })
       })
     })

    this.state.selectCh.forEach(channel=>{
      personalList.push({
        type:channel.type,
        source:channel.source,
        ch:channel.name,
        chKey:channel.key,
      })
    })

    this.state.selectedMediaType.forEach((media,index)=>{
      if(media){
        personalList.push({
          type:this.state.checkedList[index].type,
          source:'',
          ch:'',
          chKey:'',
        })
      }
    })

    this.setState({
      storeObj : personalList
    })
  }

  toggleSaveMedia = () => {
    this.processStoreObj()
    this.setState(prevState => ({
			saveMediaOpen: !prevState.saveMediaOpen,
		}));
  }

  resetState = () =>{
    console.log('reset ?')
    this.setState({
      checked: [],
      selectCh: [],
      checkedList: [
        {type:"NEWS",checked:[]},
        {type:"BBS",checked:[]},
        {type:"SM",checked:[]},
        {type:"BLOG",checked:[]},
      ],
      selectedMediaType: [false,false,false,false],
    })
  }

  // (2021 08 17)
  // todo 
  // delete logic rewrite

  // READ a media list
  handleListSelect(listId) {
    const normalFetch = myFetchWithId("", true, true);

    this.setState({loading: true});
    try {
    	normalFetch(`${mediaApi}/get_sclist`, {id: listId})
    	.then( data => {
    		this.props.selecteMyMediaList(listId, this.props.savedMediaList);
    		if ((data.response_data||[]).list.length > 0) {
          const newList=this.state.checkedList
          const newType = this.state.selectedMediaType
          const newSource = this.state.checked
          const newChannel = this.state.selectCh

          data.response_data.list.forEach(item => {
            if(item.channel && item.glb_channel_key){
              newChannel.push({
                name:item.channel,
                source:item.source,
                type:item.type,
                key:item.glb_channel_key
              })
            }
            else if(item.type && item.channel === '' && item.glb_channel_key === '' && item.source === ''){
              newList.forEach((media,index)=>{
                if(media.type === item.type){
                  newType[index] = true
                }
              })
            }
            else{
              newSource.push(item.source)
              newList.forEach((media,index)=>{
                if(media.type === item.type){
                  newList[index].checked.push(item.source)
                }
              })
            }
          })

    			this.setState({
            loading: false,
            checked: newSource,
            selectCh:newChannel,
            selectedMediaType:newType,
            checkedList:newList,
            loading: false,
            myMediaOpen:false,
          });
          
    		} else {
          console.log('no data')
          alert('此清單並沒有儲存任何頻道');
    			this.setState({
    				loading: false
    			});
    		}
    	})
    } catch (err) {
    		this.props.updateError(err);
    		this.setState({loading: false})
    }
  }

  _removeChtoList(channel, source, type) {
    const targetId = this.props.selectedMediaId;
    const normalFetch = myFetchWithId("", true, true);
    console.log("delete channel");
    // try {
    // 	normalFetch(`${mediaApi}/delete_sc_from_sclist`, {id: targetId, channel: channel, source: source, type: type})
    // 	.then( data => {
    // 		console.log(data);
    // 	})
    // } catch (err) {
    // 		this.props.updateError(err);
    // }
  }

  medialistTitle() {
    const targetList =
      this.props.savedMediaList.filter(
        obj => obj.id === this.props.selectedMediaId
      )[0] || {};
    const listName =
      targetList === {}
        ? decodeURIComponent(this.props.savedMediaList[0].name)
        : decodeURIComponent(targetList.name);

    if (listName===undefined) {
      return null;
    } else {
      return listName;
    }
  }


  checkCh(val, targetNode) {
    // val 是當前所全部選取的 source
    const typeindex = this.state.activeTab;
    const nowcheck = targetNode.value;

    let checked=this.state.checked;
    let checkedList = this.state.checkedList
    let temp = this.state.temp;
    let tempList = this.state.tempList;
    let tempcheck =[]
    let tempcheckList = [
    {type:"NEWS",checked:[]},
    {type:"BBS",checked:[]},
    {type:"SM",checked:[]},
    {type:"BLOG",checked:[]},
  ]

  // TODO : 重整這裡(可以使用 但有點雜)
  // 2020 10 20 因為是應急方法寫法有點醜，不應該用這麼多變數來管理同一個狀態
  // 2020 10 20 這邊的作法應該要是 從 redux 接收上一次的狀態 =>把此次開啟 mediafilter 後的變更作紀錄 => 基於上一次狀態變更(apply套用 cancel不儲存)

  // checkedList => 儲存在自己的頻道列表用----------------------------//
    tempList = tempList.map((item, index) => {
      if (index === typeindex) {
        // 判別 source 是被選取還是被取消
        if(targetNode.checked){
          item.checked.push(nowcheck)
          return { type: item.type, checked:item.checked};
        }
        else{
          return item;
        }
      } else {
        return item;
      }
    });

      tempcheckList.map((item,index)=>{
        item.checked = checkedList[index].checked.concat(tempList[index].checked)
      })

    tempcheckList.map((item,index)=>{
      if(!targetNode.checked){
        item.checked = item.checked.filter(item=> item != nowcheck)
        tempList = tempList.filter(item => item != nowcheck)
        return { type: item.type, checked:item.checked};
      }
    })
  
    tempcheckList.map((item,index)=>{
      item.checked = item.checked.filter((obj,index)=>item.checked.indexOf(obj)===index)
    })

  // checked => 顯示在 selectmedia 和 checkbox 的狀態資料-------------------------------------//
    temp = temp.filter((item,index)=>checked.indexOf(item)===index)
    temp.push(nowcheck)

    if(targetNode.checked){
      checked = checked.concat(temp)
      tempcheck = checked.filter((item,index)=>checked.indexOf(item)===index)
    }
    else{
      tempcheck = checked.filter(item => item != nowcheck)
      temp = temp.filter(item => item != nowcheck)
    }
  //------------------------------//

    this.setState({
      checked: tempcheck,
      checkedList: tempcheckList,
      temp :[],
      tempList:[
        {type:"NEWS",checked:[]},
        {type:"BBS",checked:[]},
        {type:"SM",checked:[]},
        {type:"BLOG",checked:[]},
      ],
    });
  }

  checkMediaType(i) {
    const newType = this.state.selectedMediaType.map((el, index) => {
      if (i === index) {
        const boo = this.state.selectedMediaType[i];
        return !el;
      } else {
        return el;
      }
    });

      this.setState((prevState) => ({
        selectedMediaType: newType,
        }));
  }

  filter(event) {
    let updatedNews = this.props.newsList.filter(item => {
      return (
        item.value.toLowerCase().indexOf(event.target.value.toLowerCase()) !==
        -1
      );
    });
    let updatedBbs = this.props.bbsList.filter(item => {
      return (
        item.value.toLowerCase().indexOf(event.target.value.toLowerCase()) !==
        -1
      );
    });
    let updatedBlog = this.props.blogList.filter(item => {
      return (
        item.value.toLowerCase().indexOf(event.target.value.toLowerCase()) !==
        -1
      );
    });
    let updatedSm = this.props.smList.filter(item => {
      return (
        item.value.toLowerCase().indexOf(event.target.value.toLowerCase()) !==
        -1
      );
    });

    this.setState({
      news: updatedNews,
      bbs: updatedBbs,
      blog: updatedBlog,
      sm: updatedSm
    });

    switch (this.state.activeTab) {
      case 0:
        this.setState({ displayMedia: updatedNews });
        break;
      case 1:
        this.setState({ displayMedia: updatedBbs });
        break;
      case 2:
        this.setState({ displayMedia: updatedSm });
        break;
      case 3:
        this.setState({ displayMedia: updatedBlog });
        break;
      default:
        return null;
    }
  }

  toggle(index) {
    if (this.state.activeTab !== index) {
      this.setState({ activeTab: index });
    }
    switch (index) {
      case 0:
        this.setState({
          displayMedia: this.state.news,
          disabledchecked: this.state.selectedMediaType[0]
        });
        break;
      case 1:
        this.setState({
          displayMedia: this.state.bbs,
          disabledchecked: this.state.selectedMediaType[1]
        });
        break;
      case 2:
        this.setState({
          displayMedia: this.state.sm,
          disabledchecked: this.state.selectedMediaType[2]
        });
        break;
      case 3:
        this.setState({
          displayMedia: this.state.blog,
          disabledchecked: this.state.selectedMediaType[3]
        });
        break;
      default:
        return null;
    }
  }
  setType(type) {
    this.setState({ filterType: type });
  }

  apply() {
    const types = [...this.state.selectedMediaType];
    const checkedList = this.state.checkedList;

    const AllChecked = this.state.checked

    const checkedCh = [];
    const checkedType = [];
    const typeTag = []

    types.forEach((item,index)=>{
      if(item){
        typeTag.push(this.state.mediaType[index].title)
      }
    })
    
    for (let i = 0; i < types.length; i++) {
      if (this.state.filterType === 1) {
        if (types[i]) {
          checkedType.push(checkedList[i].type);
        } else {
          checkedCh.push(...checkedList[i].checked);
        }
      } else {
        if (!types[i]) {
          checkedType.push(checkedList[i].type);
          checkedCh.push(...checkedList[i].checked);
        }
      }
    }

    const keys = this.state.selectCh.map(ch => ch.key);
    const ch = this.state.selectCh
    this.props.applyChKey(this.state.filterType,ch,keys);

    let filltertype = true
    if (this.state.filterType === 1) {
      this.props.applyMedia(AllChecked); //store data in search/checkfromredux、source
      this.props.applyNotMedia("CLEAN"); // clean data from not-type-query's data
      this.props.applyType(
        filltertype,
        typeTag,
        checkedType,
        this.state.checkedList, 
        this.state.selectedMediaType // only store media-type not single media
      );
    } else {
      filltertype = false
      this.props.applyMedia("CLEAN");
      this.props.applyNotMedia(AllChecked);
      this.props.applyType(
        filltertype,
        typeTag,
        checkedType,
        this.state.checkedList, 
        this.state.selectedMediaType
      );
    }
    this.props.filterAction(this.state.filterType); // store the select-query-type
    this.props.closeModal();
  }

  

  cleanChecked() {
    this.setState({
      checked: [],
      checkedList: [
        { type: "NEWS", checked: [] },
        { type: "BBS", checked: [] },
        { type: "SM", checked: [] },
        { type: "BLOG", checked: [] }
      ]
    });
  }

  //2020 10 20 新增
  deleteChecked =(obj)=>{
   if(obj.key){
     const result = this.state.selectCh.filter((item)=>item != obj)
     this.setState({
      selectCh:result
     })
   }
   else{
    const result = this.state.checked.filter((item)=>item != obj)

    let theIndex =''

    const newCheckedList = this.state.checkedList.map((item, index) => {

      if(item.checked.find((item)=> item === obj)){
        theIndex = index
      }

      if (index === theIndex) {
          item.checked = item.checked.filter(item=> item != obj)
          return { type: item.type, checked:item.checked};
      } else {
        return item;
      }
    });

    this.setState({
      checked:result,
      checkedList:newCheckedList
    })
   }
  }

  cancelAll =(type)=>{
    if(type === 'selectCh'){
      this.setState({
        selectCh:[]
      })
    }
    else if(type === 'selectSource'){
      this.setState({
        checked:[],
        checkedList:[
          { type: "NEWS", checked: [] },
          { type: "BBS", checked: [] },
          { type: "SM", checked: [] },
          { type: "BLOG", checked: [] }
        ]
      })
    }
  }
  
  selectChannel = (ch) => {
    this.setState({selectCh: ch});
  }

  toggleMyMediaList = () => {
    this.props.fetchMyMediaList()
    this.setState(prevState => ({ myMediaOpen: !prevState.myMediaOpen}));
  }

  closeMediaFilter = () =>{
    this.props.closeModal()
  }

  render() {
    return (
      <div className="popup-modal ad-search-popup">
        {/* Head */}
        <div className="popup-modal-header">
          <h3>頻道來源選擇</h3>
        </div>

        {/* Body */}
        <div className="popup-modal-content">
          {/* Nav bar */}

          <div className="popup-modal-filter-actions">  


            <Button color="primary" onClick={this.toggleMyMediaList}>我的頻道</Button>


            <SearchChannel selectChannel={this.state.selectCh} select={this.selectChannel}/>

            <div className="popup-modal-filter-action-2">
              <FormGroup check>
                <Label check>
                  <Input
                    type="radio"
                    name="radio1"
                    checked={this.state.filterType === 1 ? true : false}
                    onChange={() => {
                      this.setType(1);
                    }}
                  />
                  僅看所選擇的條件
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check>
                  <Input
                    type="radio"
                    name="radio2"
                    checked={this.state.filterType === 2 ? true : false}
                    onChange={() => {
                      this.setType(2);
                    }}
                  />
                  排除所選擇的條件
                </Label>
              </FormGroup>
            </div>
          </div>


          {/* Content */}

          <div className="popup-modal-list">
            <div className="popup-modal-subpanel">

              <Nav tabs>
                {this.state.mediaType.map((media, index) => (
                  <NavItem key={index}>
                    <NavLink
                      className={classnames({
                        active: this.state.activeTab === index
                      })}
                      onClick={() => {
                        this.toggle(index);
                      }}
                    >
                      <input
                        className="select-media-type"
                        type="checkbox"
                        checked={this.state.selectedMediaType[index]}
                        onChange={() => {
                          this.checkMediaType(index);
                        }}
                      />
                      <h5>
                        {/* {media.title}-{media.num} */}
                        {media.title}
                      </h5>
                    </NavLink>
                  </NavItem>
                ))}
              </Nav>

              <div className="media-checkboxtree">
              
              <div className="media-checkboxtree__search-bar">
                  <input
                    id="search"
                    type="text"
                    placeholder="搜尋媒體名稱"
                    onChange={this.filter}
                  />
              </div>

                <CheckboxTree
                  nodes={this.state.displayMedia}
                  checked={this.state.checked}
                  expanded={this.state.expanded}
                  onCheck={(checked, targetNode) =>
                    this.checkCh(checked, targetNode)
                  }
                  onExpand={expanded => this.setState({ expanded })}
                  // disabled={this.state.disabledchecked}
                />

              </div>
            </div>
            {/*show selected area*/}
            <SelectedMedias 
              selectSource={this.state.checked}
              selectCh={this.state.selectCh}
              filterType={this.state.filterType}
              deleteChecked = {this.deleteChecked}
              cancelAll ={this.cancelAll}
            />
          </div>

          {/* ------ button ------ */}
          <div className="popup-modal-buttonset">
            <button className="cancel" onClick={this.closeMediaFilter}>
              取消
            </button>


            <button className="cancel" onClick={this.toggleSaveMedia}>
              儲存為我的頻道
            </button>


            <button className="apply" onClick={this.apply}>
              套用至搜尋條件
            </button>
          </div>


        </div>


        <Modal size='mid' isOpen={this.state.saveMediaOpen} toggle={this.toggleSaveMedia}>
					<SaveItem
						title={'頻道'}
						addItemApi={`${mediaApi}/add_sc_to_sclist`}
						addListApi={`${mediaApi}/create_sclist`}
            getListApi={`${mediaApi}/get_sclist`}
						refreshAction={() => {this.props.fetchMyMediaList(true)}}
						saveObj={this.state.storeObj}
						savedList={this.props.savedMediaList}
						cancel={this.toggleSaveMedia}
            resetState = {this.resetState}
					/>
				</Modal>


          
				<Modal size='sm' isOpen={this.state.nameMediaOpen} toggle={this.toggleNameMedia}>
					<div className="popup-modal">
						<div className="popup-modal-header">
							<h3>請設定此頻道組合的名稱</h3>
						</div>
						<div className="popup-modal-content">
			        <Form>
			          <FormGroup>
									{this.state.mediaNameAlert === true
										?	<Alert color="danger">名稱不可為空白</Alert> : null
									}
									{this.state.mediaSelectAlert === true
										?	<Alert color="danger">你未選擇任何頻道，請至少勾選一個頻道</Alert> : null
									}
			            <Input type="text" id="widgetName" value={this.state.myMediaName} onChange={this.setMyMediaName}/>
			          </FormGroup>
			        </Form>
		          <div className="popup-modal-buttonset">
		            <button className="apply" onClick={this.save}>
		              儲存
		            </button>
		            <button className="cancel" onClick={this.toggleNameMedia}>
		              取消
		            </button>
		          </div>
		        </div>
					</div>
				</Modal>

        <Modal size='sm' isOpen={this.state.myMediaOpen} toggle={this.toggleMyMediaList}>
          <Loader show={this.state.loading} message={spinner}>
					  <div className="popup-modal">
						  <div className="popup-modal-header">
							  <h3>個人頻道組合</h3>
						  </div>
						  <div className="popup-modal-content mymedia-list">
                <CreateItem
                  apiCall={`${mediaApi}/create_sclist`}
                  fetchItem={this.props.fetchMyMediaList}
                  updateError={this.props.updateError}
                  contentText={'請設定此媒體清單的名稱'}
                  formdata={true}
                >
                  {({toggleNameSet}) => (
                    <button id="add-buttn" onClick={toggleNameSet}>新增媒體清單</button>
                  )}
                </CreateItem>
							  <ul>
                  {this.props.savedMediaList.map( (media,index) =>
                    <li className='my-media-title' key={index}>
                    {/* 個人清單 */}
                      <span onClick={() => this.handleListSelect(media.id)}>{decodeURIComponent(media.name)}</span>
                    {/*  */}
                      <UpdateItem
                        apiCall={`${mediaApi}/update_sclist`}
                        fetchItem={() => {this.props.fetchMyMediaList(true)}}
                        updateError={this.props.updateError}
                        contentText={'重新命名此媒體的名稱'}
                      >
                        {({toggleRename}) => (
                          <i className='icon-pencil icons lowi-icon widget-tip' onClick={() => toggleRename(media.id, media.name)}>
                            <span className="widget-tiptext"></span>
                          </i>
                        )}
                      </UpdateItem>
                      <DeleteItem
                        apiCall={`${mediaApi}/delete_sclist`}
                        fetchItem={() => {this.props.fetchMyMediaList(false)}}
                        updateError={this.props.updateError}
                        setInit={() => {}}
                      >
                        {({toggleDelete}) => (
                          <i className='icon-trash icons lowi-icon widget-tip' onClick={() => toggleDelete(media.id, media.name)}>
                            <span className="widget-tiptext"></span>
                          </i>
                        )}
                      </DeleteItem>
                    </li>
                  )}
							  </ul>
		            <div className="popup-modal-buttonset">
		              <button className="cancel" onClick={this.toggleMyMediaList}>
		                取消
		              </button>
		            </div>
		          </div>
					  </div>
          </Loader>
				</Modal>
      </div>
    );
  }
}

const MediaFilter = connect(
  mapStateToProps,
  mapDispatchToProps
)(MediaFilterComponent);

export default MediaFilter;


// WEBPACK FOOTER //
// ./src/components/popup/mediaFilter.js